import ServicoForm from "./ServicoForm";
export default function Form() { return <ServicoForm />; }
